/**
 * Shared buy-flow helper.
 *
 * Opens Stripe Checkout in a new tab when a payment URL is configured, and
 * tracks the click. When Stripe isn't configured yet (e.g. local dev, or before
 * the payment link is pasted into env), it degrades gracefully by scrolling the
 * buyer to the pricing section instead of doing nothing.
 */
import { buildStripeUrl } from './environment';
import { trackCheckoutSessionStarted } from './analytics';

export const startCheckout = (location = 'unknown') => {
  trackCheckoutSessionStarted(location);

  const url = buildStripeUrl();
  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }

  // Fallback: no payment link configured — send them to pricing details.
  const el = document.getElementById('pricing');
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};
